import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

function fetchImage(word) {
  const key = word.word.toLowerCase().trim();
  if (!cache.has(key)) {
    const p = api
      .post("/word-images", { word: word.word, definition: word.definition || "" })
      .then((r) => (r.data.status === "ready" ? `${process.env.REACT_APP_BACKEND_URL}${r.data.url}` : null))
      .catch(() => null);
    cache.set(key, p);
    p.then((url) => { if (!url) cache.delete(key); });
  }
  return cache.get(key);
}

export function useWordImage(word) {
  const [state, setState] = useState({ url: null, loading: true });
  useEffect(() => {
    let alive = true;
    setState({ url: null, loading: true });
    fetchImage(word).then((url) => alive && setState({ url, loading: false }));
    return () => { alive = false; };
  }, [word.word]); // eslint-disable-line react-hooks/exhaustive-deps
  return state;
}
